'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemFacets = require('./mock/itemFacets');

var _itemFacets2 = require('./remote/itemFacets');

var ItemFacets = {
    fetchItemFacets: function fetchItemFacets(params) {
        return __MOCK__ ? _itemFacets.ItemFacetsMock.fetchItemFacets(params) : _itemFacets2.ItemFacetsRemote.fetchItemFacets(params);
    }
};

exports.default = ItemFacets;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/itemFacets.js
// module id = ZbCA
// module chunks = 57